<template>
  <v-card
    v-if="active"
    elevation="0"
    outlined
    class="colorDominant colorBreadcrumbs px-0"
    :class="$vuetify.breakpoint.smAndDown ? 'darken-1' : ''"
  >
    <div class="d-flex flex-nowrap transparent px-2 align-center">
      <v-btn
        fab
        depressed
        class="transparent"
        x-small
        @click="onBackButtonClick"
      >
        <v-icon size="24">mdi-arrow-left</v-icon>
      </v-btn>
      <v-divider vertical class="my-2 mx-2"></v-divider>
      <!-- <v-app-bar-nav-icon v-on:click="[$router.go(-1)]">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon> -->
      <v-breadcrumbs
        :items="breadcrumbs"
        link
        class="pa-2 d-flex flex-nowrap text-truncate"
      >
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            :to="item.href"
            :disabled="item.disabled || $route.path.includes('worldCup')"
          >
            <span v-if="item.text">
              {{ item.text }}
            </span>
            <span v-else>
              <v-icon>mdi-dots-horizontal</v-icon>
            </span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
  </v-card>
</template>
<script>
export default {
  props: ["promotionTitle"],
  name: "breadcrumbs",
  data: () => {
    return {
      active: false,
    };
  },
  mounted() {
    this.active = this.$route.name !== "Sports";
  },
  computed: {
    fromMyPromotions() {
      return this.$route.query &&
        this.$route.query.from === 'my-promotions'
    },
    breadcrumbs: function() {
      const items = [];
      const { params, query } = this.$route;

      if (this.$route.matched[1].path === "/live") {
        const item = {
          text: this.$t("live"),
          disabled: true,
        };
        items.push(item);
      }

      if (this.$route.params.special) {
        const item = {
          text: this.$t("specials"),
          disabled: true,
        };
        items.push(item);
      }

      if (query.sport || query.live) {
        const item = {
          text: query.sport ? query.sport : query.live,
          disabled: true,
        };
        items.push(item);
      }

      if (query.category) {
        const item = {
          text: query.category ? query.category : params.category,
          disabled: this.$route.params.special ? true : false,
          href: `/category/${params.sport}/${params.category}/?sport=${query.sport}&category=${query.category}`,
        };
        items.push(item);
      }

      if (query.tournament) {
        const item = {
          text: query.tournament ? query.tournament : params.tournament,
          disabled: false,
          href: `/tournament/${params.sport}/${params.category}/${params.tournament}?sport=${query.sport}&category=${query.category}&tournament=${query.tournament}`,
        };
        items.push(item);
      }

      if (query.event) {
        const item = {
          text: query.event ? query.event : params.event,
          disabled: true,
        };
        items.push(item);
      }

      if (this.$route.name === "PromotionDetail") {
        const promotions = {
          text: this.$t("promotions"),
          disabled: true,
        };
        const currentPromotion = {
          text: this.promotionTitle || "",
          disabled: true,
        };

        items.push(promotions, currentPromotion);
      }

      return items;
    },
  },

  methods: {
    onBackButtonClick() {
      if (this.$route.name === "PromotionDetail") {
        if (this.fromMyPromotions) {
          this.$router.push({
            name: "MyPromotions"
          });
        } else {
          this.$router.push({ name: "AllPromotions" });
        };
      } else {
        if (this.$route.name === "BetSuccessEventsCategoryEvent") {
          this.$router.push({
            name: "category",
            query: {
              sport: this.$route.query.sport,
              category: this.$route.query.category,
            },
          });
        } else if (this.$route.name === "BetSuccessLiveEvent") {
          this.$router.push({
            name: "live",
            query: {
              live: this.$route.query.sport,
            },
          });
        } else if (
          this.$route.name === "eventsTournament" ||
          this.$route.name === "BetSuccessTournamentEvent"
        ) {
          this.$router.push({
            name: "tournament",
            query: {
              sport: this.$route.query.sport,
              tournament: this.$route.query.tournament,
              category: this.$route.query.category,
            },
          });
        } else {
          this.$router.go(-1);
        }
      }
    },
  },
};
</script>
